import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import styled, { css } from "styled-components";

export const TopicsList = styled(FlexColumn)<{ isDisabled: boolean }>`
    width: 100%;
    position: relative;
    max-height: 700px;
    padding: 0;

    ${({ isDisabled }) =>
        isDisabled
            ? css`
                  overflow: hidden;
                  height: 422px;
              `
            : css`
                  overflow: auto;
              `}
`;
